module.exports = __webpack_public_path__ + "static/mgrenier@2x-ce27c509a6dcd1836f03080d59686aa6.jpg";